<template>
  <div class="container-fluid mt-5">
    <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
      <div class="row">
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_CAFETERIAS)"
          :to="{ name: 'List Cafeterias' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span class="shortcut-media avatar avatar-xl rounded-circle bg-info">
              <i class="ni ni-2x ni-shop"></i>
            </span>
            <small>{{ $t("COMMON.CAFETERIAS") }}</small>
          </a>
        </router-link>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_ESTABLISHMENTS)"
          :to="{ name: 'List Establishments' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span class="shortcut-media avatar avatar-xl rounded-circle bg-info">
              <i class="ni ni-2x ni-building"></i>
            </span>
            <small>{{ $t("COMMON.ESTABLISHMENTS") }}</small>
          </a>
        </router-link>
        <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_SERVICECENTERS)"
          :to="{ name: 'List ServiceCenters' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span class="shortcut-media avatar avatar-xl rounded-circle bg-info">
              <i class="ni ni-2x ni-square-pin"></i>
            </span>
            <small>{{ $t("COMMON.SERVICECENTERS") }}</small>
          </a>
        </router-link>
        <router-link
          v-if="
            $currentUserCan($permissions.PERM_VIEW_MODULE_WEEKLY_REPORTS) &&
            $currentUserDoesWeeklyReports()
          "
          :to="{ name: 'List WeeklyReports' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span class="shortcut-media avatar avatar-xl rounded-circle bg-info">
              <i class="ni ni-2x ni-calendar-grid-58"></i>
            </span>
            <small>{{ $t("COMMON.WEEKLY_REPORTS") }}</small>
          </a>
        </router-link>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  layout: "DashboardLayout",

  components: {},

  mixins: [],

  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>
